import styled, { css } from 'styled-components'

import theme from 'theme_'
import { Font12, Font14 } from 'components/Typography'
import { TableWithPaginationWrapper } from 'components/Table/styles'

export const AddedLicensesContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 40px;
`

export const AddedLicensesHeader = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 16px;
`

export const Title = styled.div`
  font-weight: 900;
  font-size: 20px;
  line-height: 32px;
`

export const RowsCount = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 16px;
  background: ${theme.colors.lightGrey};
  border-radius: 8px;
  font-weight: normal;
  ${Font14};
  margin-left: 16px;
`

export const StyledTableInnerWrapper = styled.div`
  @media ${theme.devices.tablet} {
    min-width: 1000px;
  }
`

export const StyledTableOuterWrapper = styled(TableWithPaginationWrapper)`
  box-shadow: 10px 10px 10px rgba(0, 0, 0, 0.02);
  border-radius: 8px;
  margin-bottom: 8px;
`

export const CellStyles = css`
  word-break: break-all;
  padding: 12px 12px;
  ${Font12};

  &:first-child {
    padding-left: 24px;
  }

  &:last-child {
    padding-right: 24px;
  }
`

export const CellStylesDate = css`
  ${CellStyles};
  word-break: unset;
`

export const AddedLicensesMobileTitle = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.tiny};
`
